import {useMutation, useQueryClient} from 'react-query';
import PostFertilizerAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostFertilizerAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostFertilizerAdvertisement = ({
  onSuccess,
}: IPostFertilizerAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IFertilizerAdvertisementPayload) =>
      PostFertilizerAdvertisement(payload),
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {mutate, isLoading};
};
export {usePostFertilizerAdvertisement};
